import React from "react";

export const icons = {
  undo: (
    <svg width="16" height="7" viewBox="0 0 16 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.375 1C6.3875 1 4.5875 1.7425 3.2 2.95L0.5 0.25V7H7.25L4.535 4.285C5.5775 3.415 6.905 2.875 8.375 2.875C11.03 2.875 13.2875 4.6075 14.075 7L15.8525 6.415C14.81 3.2725 11.8625 1 8.375 1Z"
        fill="#616161"
      />
    </svg>
  ),
  redo: (
    <svg width="16" height="7" viewBox="0 0 16 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7998 2.95C11.4123 1.7425 9.61229 1 7.62479 1C4.13729 1 1.18979 3.2725 0.154785 6.415L1.92479 7C2.71229 4.6075 4.96229 2.875 7.62479 2.875C9.08729 2.875 10.4223 3.415 11.4648 4.285L8.74979 7H15.4998V0.25L12.7998 2.95Z"
        fill="#616161"
      />
    </svg>
  ),
  clearMap: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
        fill="#616161"
      />
    </svg>
  ),
  addToRoute: (
    <svg
      style={{ marginBottom: "5px", marginTop: "5px" }}
      width="20"
      height="10"
      viewBox="0 0 20 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1666 1.66667C19.1666 2.58333 18.4166 3.33333 17.4999 3.33333C17.3499 3.33333 17.2082 3.31667 17.0749 3.275L14.1082 6.23333C14.1499 6.36667 14.1666 6.51667 14.1666 6.66667C14.1666 7.58333 13.4166 8.33333 12.4999 8.33333C11.5832 8.33333 10.8332 7.58333 10.8332 6.66667C10.8332 6.51667 10.8499 6.36667 10.8916 6.23333L8.76658 4.10833C8.63325 4.15 8.48325 4.16667 8.33325 4.16667C8.18325 4.16667 8.03325 4.15 7.89992 4.10833L4.10825 7.90833C4.14992 8.04167 4.16658 8.18333 4.16658 8.33333C4.16658 9.25 3.41658 10 2.49992 10C1.58325 10 0.833252 9.25 0.833252 8.33333C0.833252 7.41667 1.58325 6.66667 2.49992 6.66667C2.64992 6.66667 2.79158 6.68333 2.92492 6.725L6.72492 2.93333C6.68325 2.8 6.66658 2.65 6.66658 2.5C6.66658 1.58333 7.41658 0.833333 8.33325 0.833333C9.24992 0.833333 9.99992 1.58333 9.99992 2.5C9.99992 2.65 9.98325 2.8 9.94158 2.93333L12.0666 5.05833C12.1999 5.01667 12.3499 5 12.4999 5C12.6499 5 12.7999 5.01667 12.9332 5.05833L15.8916 2.09167C15.8499 1.95833 15.8332 1.81667 15.8332 1.66667C15.8332 0.75 16.5832 0 17.4999 0C18.4166 0 19.1666 0.75 19.1666 1.66667Z"
        fill="#616161"
      />
    </svg>
  ),
  dropPoi: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7.83333C4 4.61667 6.61667 2 9.83333 2C13.05 2 15.6667 4.61667 15.6667 7.83333C15.6667 12.2083 9.83333 18.6667 9.83333 18.6667C9.83333 18.6667 4 12.2083 4 7.83333ZM10.6668 8.66657H13.1668V6.99991H10.6668V4.49991H9.00014V6.99991H6.50014V8.66657H9.00014V11.1666H10.6668V8.66657Z"
        fill="#616161"
      />
    </svg>
  ),
  customCue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66675 6.85185H3.5186V5H1.66675V6.85185ZM3.5186 10.5556H1.66675V8.70372H3.5186V10.5556ZM3.5186 14.2593H1.66675V12.4074H3.5186V14.2593ZM18.3334 10.5556H5.3704V8.70372H18.3334V10.5556ZM5.3704 14.2593H18.3334V12.4074H5.3704V14.2593ZM5.3704 6.85185V5H18.3334V6.85185H5.3704Z"
        fill="#616161"
      />
    </svg>
  ),
  controlPoint: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="-7.28523e-08" y1="9.8335" x2="20" y2="9.83349" stroke="#616161" strokeWidth="2" />
      <circle cx="10.0001" cy="10.0001" r="4.83333" fill="white" stroke="#616161" strokeWidth="2" />
      <circle cx="10" cy="10" r="2" fill="#616161" stroke="#616161" />
    </svg>
  ),
  cycling: (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1427 2.15036C13.1427 2.86869 12.5714 3.44346 11.8571 3.44346C11.1428 3.44346 10.5715 2.86861 10.5715 2.15028C10.5715 1.43196 11.1428 0.857178 11.8571 0.857178C12.5714 0.857178 13.1427 1.43203 13.1427 2.15036ZM10.4286 12.0435C10.4286 10.068 12.0357 8.4516 14 8.4516C15.9643 8.4516 17.5714 10.068 17.5714 12.0435C17.5714 14.0191 15.9643 15.6355 14 15.6355C12.0357 15.6355 10.4286 14.0191 10.4286 12.0435ZM14 14.5579C12.6071 14.5579 11.5001 13.4445 11.5001 12.0435C11.5001 10.6426 12.6071 9.52919 14 9.52919C15.393 9.52919 16.5001 10.6426 16.5001 12.0435C16.5001 13.4445 15.393 14.5579 14 14.5579ZM13.898 7.01481H10.8979L9.74994 5.30095L8.10721 7.01481L9.6123 8.24634V12.5567H8.38781V9.25211L6.03591 7.77928C5.67878 7.56376 5.32663 7.20454 5.32663 6.73771C5.32663 6.41444 5.46943 6.09116 5.6838 5.87565L8.42857 3.21766C8.64293 3.00211 8.96428 2.85848 9.28571 2.85848C9.71428 2.85848 10.1071 3.10983 10.3216 3.46901L11.6463 5.78328H13.898V7.01481ZM4.00001 8.4516C2.03573 8.4516 0.428589 10.068 0.428589 12.0435C0.428589 14.0191 2.03573 15.6355 4.00001 15.6355C5.96428 15.6355 7.57142 14.0191 7.57142 12.0435C7.57142 10.068 5.96428 8.4516 4.00001 8.4516ZM1.50004 12.0435C1.50004 13.4445 2.60718 14.5579 4.00003 14.5579C5.39285 14.5579 6.50002 13.4445 6.50002 12.0435C6.50002 10.6426 5.39289 9.52919 4.00003 9.52919C2.60721 9.52919 1.50004 10.6426 1.50004 12.0435Z"
        fill="currentColor"
      />
    </svg>
  ),
  driving: (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8888 0.333252C13.4669 0.333252 13.9556 0.686259 14.1335 1.216L15.9999 6.0712V12.6919C15.9999 13.1772 15.5998 13.5746 15.111 13.5746H14.2221C13.7334 13.5746 13.3332 13.1773 13.3332 12.6919V12.2505H2.66655V12.6919C2.66655 13.1772 2.26642 13.5746 1.77767 13.5746H0.888753C0.400045 13.5746 -0.00012207 13.1773 -0.00012207 12.6919V6.0712L1.86621 1.216C2.04417 0.686217 2.53288 0.333252 3.111 0.333252H12.8888ZM1.77769 8.27811C1.77769 9.02852 2.35578 9.60225 3.11103 9.60225C3.86619 9.60225 4.44436 9.02848 4.44436 8.27811C4.44436 7.52774 3.86628 6.95397 3.11103 6.95397C2.35578 6.95397 1.77769 7.5277 1.77769 8.27811ZM12.8886 9.60225C12.1334 9.60225 11.5553 9.02852 11.5553 8.27811C11.5553 7.5277 12.1334 6.95397 12.8886 6.95397C13.6438 6.95397 14.2219 7.52774 14.2219 8.27811C14.2219 9.02848 13.6438 9.60225 12.8886 9.60225ZM3.11103 1.65739L1.77769 5.18841H14.2221L12.8888 1.65739H3.11103Z"
        fill="currentColor"
      />
    </svg>
  ),
  walking: (
    <svg
      style={{ marginLeft: "3px" }}
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76173 1.42857C7.76173 2.22229 7.12694 2.85714 6.33327 2.85714C5.53959 2.85714 4.90459 2.22229 4.90459 1.42857C4.90459 0.634821 5.53959 0 6.33327 0C7.12694 0 7.76173 0.634821 7.76173 1.42857ZM10.0477 7.14286H6.33338L5.60888 5.79058L4.90373 8.00001L6.94052 11.4286V16H5.58338V12.5714L3.78688 10.1332L1.76195 16H0.333374L3.20945 4.57143L1.76195 5.14286V8.00001H0.333374V4.00001L4.31427 2.65279C4.45613 2.60936 4.6572 2.59036 4.77141 2.59036C5.22845 2.59036 5.60123 2.82143 5.87616 3.23811L7.47623 5.71429H10.0477V7.14286Z"
        fill="currentColor"
      />
    </svg>
  ),
  reverseRoute: (
    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00025 0.249817C12.1402 0.249817 15.5002 1.92982 15.5002 3.99982C15.5002 5.67982 13.2952 7.09731 10.2502 7.57731V9.99981L7.25025 6.99981L10.2502 3.99982V6.04732C12.6127 5.62732 14.0002 4.62232 14.0002 3.99982C14.0002 3.20482 11.7202 1.74982 8.00025 1.74982C4.28025 1.74982 2.00025 3.20482 2.00025 3.99982C2.00025 4.54732 3.09525 5.41732 5.00025 5.89732V7.43481C2.35275 6.85731 0.500248 5.53732 0.500248 3.99982C0.500248 1.92982 3.86025 0.249817 8.00025 0.249817Z"
        fill="#616161"
      />
    </svg>
  ),
  outAndBack: (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.856934 3.56397L3.85693 0.571472L6.85693 3.56397H4.60693V8.82148H3.10693V3.56397H0.856934ZM9.10701 5.82128V11.0788H11.357L8.35701 14.0713L5.35701 11.0788H7.60701V5.82128H9.10701Z"
        fill="#616161"
      />
    </svg>
  ),
  duplicate: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9998 0.749939H2.99976C2.17476 0.749939 1.49976 1.42494 1.49976 2.24994V12.7499H2.99976V2.24994H11.9998V0.749939ZM14.2498 3.74994H5.99976C5.17476 3.74994 4.49976 4.42494 4.49976 5.24994V15.7499C4.49976 16.5749 5.17476 17.2499 5.99976 17.2499H14.2498C15.0748 17.2499 15.7498 16.5749 15.7498 15.7499V5.24994C15.7498 4.42494 15.0748 3.74994 14.2498 3.74994ZM5.99976 15.7499H14.2498V5.24994H5.99976V15.7499Z"
        fill="#616161"
      />
    </svg>
  ),
  splitRoute: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.625 7.125C13.8525 7.125 13.2 7.59 12.9075 8.25H10.7175C10.425 7.59 9.7725 7.125 9 7.125C8.2275 7.125 7.575 7.59 7.2825 8.25H5.0925C4.8 7.59 4.1475 7.125 3.375 7.125C2.34 7.125 1.5 7.965 1.5 9C1.5 10.035 2.34 10.875 3.375 10.875C4.1475 10.875 4.8 10.41 5.0925 9.75H7.2825C7.575 10.41 8.2275 10.875 9 10.875C9.7725 10.875 10.425 10.41 10.7175 9.75H12.9075C13.2 10.41 13.8525 10.875 14.625 10.875C15.66 10.875 16.5 10.035 16.5 9C16.5 7.965 15.66 7.125 14.625 7.125Z"
        fill="#616161"
      />
      <rect
        x="3.18164"
        y="1.8999"
        width="1.5"
        height="17.25"
        transform="rotate(-34.021 3.18164 1.8999)"
        fill="#616161"
      />
    </svg>
  ),
  manualTrace: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5325 2.22248C13.825 2.51498 13.825 2.98748 13.5325 3.27998L12.16 4.65248L9.34749 1.83998L10.72 0.467483C11.0125 0.174983 11.485 0.174983 11.7775 0.467483L13.5325 2.22248ZM0.25 13.75V10.9375L8.545 2.64249L11.3575 5.45499L3.0625 13.75H0.25Z"
        fill="#616161"
      />
    </svg>
  ),
  autoTrace: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M14 4.00001C14 2.8954 14.8954 2 16 2C14.8955 2 14 1.10457 14 0C14 1.10454 13.1046 2 12 2C13.1045 2 14 2.89537 14 4.00001Z"
          fill="#616161"
        />
        <path
          d="M14.5 6.00006C14.5 6.82847 13.8284 7.50005 13 7.50005C13.8284 7.50005 14.5 8.17163 14.5 9.00004C14.5 8.1716 15.1716 7.50005 16 7.50005C15.1715 7.50009 14.5 6.82851 14.5 6.00006Z"
          fill="#616161"
        />
        <path
          d="M6.99999 5.99998C6.99999 4.34312 8.34312 2.99999 9.99998 2.99999C8.34312 2.99999 6.99999 1.65686 6.99999 0C6.99999 1.65686 5.65686 2.99999 4 2.99999C5.65686 2.99999 6.99999 4.34315 6.99999 5.99998Z"
          fill="#616161"
        />
        <path
          d="M11 2.99988L0 13.9999L2 15.9999L13 4.99988L11 2.99988ZM9.29297 6.20691L10.707 4.79287L11.207 5.29288L9.79297 6.70692L9.29297 6.20691Z"
          fill="#616161"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  selectionTools: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 3.75H3.75V2.25C2.925 2.25 2.25 2.925 2.25 3.75ZM2.25 9.75H3.75V8.25H2.25V9.75ZM5.25 15.75H6.75V14.25H5.25V15.75ZM2.25 6.75H3.75V5.25H2.25V6.75ZM9.75 2.25H8.25V3.75H9.75V2.25ZM14.25 2.25V3.75H15.75C15.75 2.925 15.075 2.25 14.25 2.25ZM3.75 15.75V14.25H2.25C2.25 15.075 2.925 15.75 3.75 15.75ZM2.25 12.75H3.75V11.25H2.25V12.75ZM6.75 2.25H5.25V3.75H6.75V2.25ZM8.25 15.75H9.75V14.25H8.25V15.75ZM14.25 9.75H15.75V8.25H14.25V9.75ZM14.25 15.75C15.075 15.75 15.75 15.075 15.75 14.25H14.25V15.75ZM14.25 6.75H15.75V5.25H14.25V6.75ZM14.25 12.75H15.75V11.25H14.25V12.75ZM11.25 15.75H12.75V14.25H11.25V15.75ZM11.25 3.75H12.75V2.25H11.25V3.75ZM5.25 12.75H12.75V5.25H5.25V12.75ZM6.75 6.75H11.25V11.25H6.75V6.75Z"
        fill="#616161"
      />
    </svg>
  ),
  deleteSelection: (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5718 4.03716H1.36615V13.2428C1.36615 14.0897 2.0535 14.777 2.90119 14.777H9.0375C9.88595 14.777 10.5718 14.0897 10.5718 13.2428V4.03716ZM4.03997 0.800049C4.03997 0.800049 3.7523 1.73576 3.28482 1.73576C2.81735 1.73576 1.36622 1.73576 1.36622 1.73576C0.94353 1.73576 0.599854 2.07944 0.599854 2.50213V3.27003H11.3397V2.50213C11.3397 2.07944 10.9961 1.73576 10.5718 1.73576C10.5718 1.73576 9.29005 1.73576 8.65477 1.73576C8.01948 1.73576 7.87565 0.800049 7.87565 0.800049H4.03997Z"
        fill="#616161"
      />
    </svg>
  ),
  flattenElevation: (
    <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 0.5L7.6875 4.25L9.825 7.1L8.625 8C7.3575 6.3125 5.25 3.5 5.25 3.5L0.75 9.5H17.25L10.5 0.5Z"
        fill="#616161"
      />
    </svg>
  ),
  changeColor: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0.25C3.2725 0.25 0.25 3.2725 0.25 7C0.25 10.7275 3.2725 13.75 7 13.75C7.6225 13.75 8.125 13.2475 8.125 12.625C8.125 12.3325 8.0125 12.07 7.8325 11.8675C7.66 11.6725 7.5475 11.41 7.5475 11.125C7.5475 10.5025 8.05 10 8.6725 10H10C12.07 10 13.75 8.32 13.75 6.25C13.75 2.935 10.7275 0.25 7 0.25ZM2.875 7C2.2525 7 1.75 6.4975 1.75 5.875C1.75 5.2525 2.2525 4.75 2.875 4.75C3.4975 4.75 4 5.2525 4 5.875C4 6.4975 3.4975 7 2.875 7ZM4 2.875C4 3.4975 4.5025 4 5.125 4C5.7475 4 6.25 3.4975 6.25 2.875C6.25 2.2525 5.7475 1.75 5.125 1.75C4.5025 1.75 4 2.2525 4 2.875ZM8.875 4C8.2525 4 7.75 3.4975 7.75 2.875C7.75 2.2525 8.2525 1.75 8.875 1.75C9.4975 1.75 10 2.2525 10 2.875C10 3.4975 9.4975 4 8.875 4ZM10 5.875C10 6.4975 10.5025 7 11.125 7C11.7475 7 12.25 6.4975 12.25 5.875C12.25 5.2525 11.7475 4.75 11.125 4.75C10.5025 4.75 10 5.2525 10 5.875Z"
        fill="#616161"
      />
    </svg>
  ),
  removeControlPoints: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25012 3.05248V1.53748C6.74262 1.68748 5.37012 2.28748 4.26012 3.19498L5.32512 4.26748C6.15762 3.62248 7.15512 3.18748 8.25012 3.05248ZM13.7401 3.19498C12.6301 2.28748 11.2576 1.68748 9.75009 1.53748V3.05248C10.8451 3.18748 11.8426 3.62248 12.6751 4.26748L13.7401 3.19498ZM16.4626 8.25H14.9476C14.8126 7.155 14.3776 6.1575 13.7326 5.325L14.8051 4.26C15.7126 5.37 16.3126 6.7425 16.4626 8.25ZM4.2676 5.325L3.1951 4.26C2.2876 5.37 1.6876 6.7425 1.5376 8.25H3.0526C3.1876 7.155 3.6226 6.1575 4.2676 5.325ZM1.5376 9.74997H3.0526C3.1876 10.845 3.6226 11.8425 4.2676 12.6675L3.1951 13.74C2.2876 12.63 1.6876 11.2575 1.5376 9.74997ZM11.2501 8.99999C11.2501 7.75499 10.2451 6.74999 9.00011 6.74999C7.75511 6.74999 6.75011 7.75499 6.75011 8.99999C6.75011 10.245 7.75511 11.25 9.00011 11.25C10.2451 11.25 11.2501 10.245 11.2501 8.99999ZM14.8051 13.7475L13.7326 12.675C14.3776 11.8425 14.8126 10.845 14.9476 9.75747H16.4626C16.3126 11.2575 15.7126 12.6375 14.8051 13.7475ZM9.75009 14.9475V16.4625C11.2576 16.3125 12.6301 15.7125 13.7401 14.805L12.6676 13.7325C11.8426 14.3775 10.8451 14.8125 9.75009 14.9475ZM8.25012 16.4625C6.75012 16.3125 5.37012 15.7125 4.26012 14.805L5.32512 13.7325C6.15762 14.3775 7.15512 14.8125 8.25012 14.9475V16.4625Z"
        fill="#616161"
      />
    </svg>
  ),
  excludeFromMetrics: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="-0.000244141"
        y="1.06091"
        width="1.5"
        height="17.25"
        transform="rotate(-45 -0.000244141 1.06091)"
        fill="#616161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49976 5.56118V12.0002H7.49976V8.56118L4.49976 5.56118ZM8.99976 10.0612V12.0004H10.939L8.99976 10.0612ZM11.9551 12.0004H11.9998V11.9557L11.9551 12.0004ZM11.9998 9.18804L8.99976 6.18804V3.7504H11.9998V9.18804ZM7.49976 4.68804L4.49976 1.68804V0.000244141H7.49976V4.68804ZM2.99976 12.0004H-0.000244141V6.0004H2.99976V12.0004Z"
        fill="#616161"
      />
    </svg>
  ),
  crop: (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 12V13.5H12.5V15H14L11.75 17.25L9.5 15H11V13.5H5C4.175 13.5 3.5 12.825 3.5 12V6H0.5V4.5H3.5V3H2L4.25 0.75L6.5 3H5V12H15.5ZM11 6H6.5V4.5H11C11.825 4.5 12.5 5.175 12.5 6V10.5H11V6Z"
        fill="#616161"
      />
    </svg>
  ),
  plus: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.583496 8.49992C0.583496 4.12992 4.13016 0.583252 8.50016 0.583252C12.8702 0.583252 16.4168 4.12992 16.4168 8.49992C16.4168 12.8699 12.8702 16.4166 8.50016 16.4166C4.13016 16.4166 0.583496 12.8699 0.583496 8.49992ZM9.29183 9.29158H12.4585V7.70825H9.29183V4.54158H7.7085V7.70825H4.54183V9.29158H7.7085V12.4583H9.29183V9.29158Z"
        fill="#616161"
      />
    </svg>
  ),
  checkmark: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75012 12.1274L3.62262 8.99988L2.55762 10.0574L6.75012 14.2499L15.7501 5.24988L14.6926 4.19238L6.75012 12.1274Z"
        fill="#212121"
      />
    </svg>
  ),
  tripleDot: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00016 8.33337C4.0835 8.33337 3.3335 9.08337 3.3335 10C3.3335 10.9167 4.0835 11.6667 5.00016 11.6667C5.91683 11.6667 6.66683 10.9167 6.66683 10C6.66683 9.08337 5.91683 8.33337 5.00016 8.33337ZM15.0002 8.33337C14.0835 8.33337 13.3335 9.08337 13.3335 10C13.3335 10.9167 14.0835 11.6667 15.0002 11.6667C15.9168 11.6667 16.6668 10.9167 16.6668 10C16.6668 9.08337 15.9168 8.33337 15.0002 8.33337ZM8.3335 10C8.3335 9.08337 9.0835 8.33337 10.0002 8.33337C10.9168 8.33337 11.6668 9.08337 11.6668 10C11.6668 10.9167 10.9168 11.6667 10.0002 11.6667C9.0835 11.6667 8.3335 10.9167 8.3335 10Z"
        fill="#212121"
      />
    </svg>
  ),
  surfaces: (
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0h16v4H0V0z" fill="#EA3223" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0h16v4H0V0z" fill="#616161" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6H0v4h16V6zM4 7H1v2h3V7zm5.5 0h-3v2h3V7zM15 7h-3v2h3V7z"
        fill="#EA3223"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6H0v4h16V6zM4 7H1v2h3V7zm5.5 0h-3v2h3V7zM15 7h-3v2h3V7z"
        fill="#616161"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 12H0v4h16v-4zm-1 1H1v2h14v-2z" fill="#EA3223" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 12H0v4h16v-4zm-1 1H1v2h14v-2z" fill="#616161" />
    </svg>
  ),
};
